import { MenuItemDef } from 'ag-grid-community'
import accountTreeIcon from '../../../../../../assets/icons/context-menu/account_tree_icon.svg'
import addRowIcon from '../../../../../../assets/icons/context-menu/add_row.svg'
import addRowsIcon from '../../../../../../assets/icons/context-menu/add_rows.svg'
import addTeamIcon from '../../../../../../assets/icons/context-menu/add_team.svg'
import addUserIcon from '../../../../../../assets/icons/context-menu/add_user.svg'
import bothDateIcon from '../../../../../../assets/icons/context-menu/both_date.svg'
import collapseRowIcon from '../../../../../../assets/icons/context-menu/collapse_row.svg'
import copyRowIcon from '../../../../../../assets/icons/context-menu/copy_row.svg'
import cutRowIcon from '../../../../../../assets/icons/context-menu/cut_row.svg'
import displayGraphIcon from '../../../../../../assets/icons/context-menu/display_graph.svg'
import earliestDateIcon from '../../../../../../assets/icons/context-menu/earliest_date.svg'
import editInformationIcon from '../../../../../../assets/icons/context-menu/edit_information.svg'
import expandRowIcon from '../../../../../../assets/icons/context-menu/expand_row.svg'
import exportRowIcon from '../../../../../../assets/icons/context-menu/export_row.svg'
import kanbanMaterialIcon from '../../../../../../assets/icons/context-menu/kanban_material_icon.svg'
import latestDateIcon from '../../../../../../assets/icons/context-menu/latest_date.svg'
import linkMaterialIcon from '../../../../../../assets/icons/context-menu/link_material_icon.svg'
import loginProjectIcon from '../../../../../../assets/icons/context-menu/login_project.svg'
import nameOnlyIcon from '../../../../../../assets/icons/context-menu/name_only.svg'
import openInNewIcon from '../../../../../../assets/icons/context-menu/open_in_new.svg'
import openProgressReportIcon from '../../../../../../assets/icons/context-menu/open_progress_report.svg'
import pasteRowIcon from '../../../../../../assets/icons/context-menu/paste_row.svg'
import reflectChildWbsIcon from '../../../../../../assets/icons/context-menu/reflect_child_wbs.svg'
import removeRowIcon from '../../../../../../assets/icons/context-menu/remove_row.svg'
import removeUserIcon from '../../../../../../assets/icons/context-menu/remove_user.svg'
import resendRegistrationEmailIcon from '../../../../../../assets/icons/context-menu/resend_registration_email.svg'
import resetPasswordIcon from '../../../../../../assets/icons/context-menu/reset_password.svg'
import selectDataIcon from '../../../../../../assets/icons/context-menu/select_data.svg'
import showDelayedWbsIcon from '../../../../../../assets/icons/context-menu/show_delayed_wbs.svg'
import showTicketListIcon from '../../../../../../assets/icons/context-menu/show_ticket_list.svg'
import sprintReportIcon from '../../../../../../assets/icons/context-menu/sprint_report.svg'
import temporaryPasswordIcon from '../../../../../../assets/icons/context-menu/temporary_password.svg'

export enum ContextMenuGroupId {
  ADD_ROW_GROUP = 'ADD_ROW_GROUP',
  MANAGE_ROW_GROUP = 'MANAGE_ROW_GROUP',
  EXPORT_ROW_GROUP = 'EXPORT_ROW_GROUP',
  CUSTOM = 'CUSTOM',
}

export interface ContextMenuGroup {
  id: ContextMenuGroupId | string
  items: MenuItemDef[]
}

export enum ContextMenuItemId {
  ADD_ROW = 'ADD_ROW',
  ADD_MULTIPLE_ROW = 'ADD_MULTIPLE_ROW',
  ADD_CHILD_ROW = 'ADD_CHILD_ROW',
  ADD_MULTIPLE_CHILD_ROW = 'ADD_MULTIPLE_CHILD_ROW',
  REMOVE_ROW = 'REMOVE_ROW',
  EXPAND_ALL = 'EXPAND_ALL',
  COLLAPSE_ALL = 'COLLAPSE_ALL',
  EXPAND_TO_LEVEL_MENU = 'EXPAND_TO_LEVEL_MENU',
  EXPORT_ALL = 'EXPORT_ALL',
  COPY_ROW = 'COPY_ROW',
  BULK_COPY_ROW = 'BULK_COPY_ROW',
  PASTE_ROW = 'PASTE_ROW',
  PASTE_ROW_AS_CHILD = 'PASTE_ROW_AS_CHILD',
  CUT_ROW = 'CUT_ROW',
  INSERT_CUT_ROW = 'INSERT_CUT_ROW',
  GET_PLAN_FROM_CHILDREN = 'GET_PLAN_FROM_CHILDREN',
  GET_PLAN_FROM_CHILDREN_BOTH_DATE = 'GET_PLAN_FROM_CHILDREN_BOTH_DATE',
  GET_PLAN_FROM_CHILDREN_EARLIEST_DATE = 'GET_PLAN_FROM_CHILDREN_EARLIEST_DATE',
  GET_PLAN_FROM_CHILDREN_LATEST_DATE = 'GET_PLAN_FROM_CHILDREN_LATEST_DATE',
  OPEN_PROGRESS_REPORT = 'OPEN_PROGRESS_REPORT',
  OPEN_SPRINT_REPORT = 'OPEN_SPRINT_REPORT',
  SEARCH_DELAYED_WBS = 'SEARCH_DELAYED_WBS',
  OPEN_TICKET_LIST = 'OPEN_TICKET_LIST',
  PASTE_ROW_AS_CHILD_NAME = 'PASTE_ROW_AS_CHILD_NAME',
  PASTE_ROW_AS_CHILD_SELECT = 'PASTE_ROW_AS_CHILD_SELECT',
  EDIT = 'EDIT',
  LOGIN_PROJECT = 'LOGIN',
  DISPLAY_GRAPH = 'DISPLAY_GRAPH',
  ADD_MEMBER = 'ADD_MEMBER',
  ADD_TEAM = 'ADD_TEAM',
  RESEND_REGISTRATION_EMAIL = 'RESEND_REGISTRATION_EMAIL',
  RESET_PASSWORD = 'RESET_PASSWORD',
  TEMPORARY_PASSWORD = 'TEMPORARY_PASSWORD',
  REMOVE_USER = 'REMOVE_USER',
  SWITCH_ROOT_WBS_ITEM = 'SWITCH_ROOT_WBS_ITEM',
  OPEN_KANBAN = 'OPEN_KANBAN',
  COPY_URL = 'COPY_URL',
  COPY_URL_AND_NAME = 'COPY_URL_AND_NAME',
}

export default class ContextMenu {
  constructor(private groups: ContextMenuGroup[]) {}

  flattenContextMenuGroups = (): (MenuItemDef | string)[] => {
    const menuItemDefs: (MenuItemDef | string)[] = []
    this.groups.forEach((group, index) => {
      group.items.forEach(item => {
        menuItemDefs.push(item)
      })
      if (index !== this.groups.length - 1 && group.items.length !== 0) {
        menuItemDefs.push('separator')
      }
    })
    return menuItemDefs
  }
}

export const getMenuIconHtml = (id: ContextMenuItemId) => {
  let icon = document.createElement('img')
  switch (id) {
    case ContextMenuItemId.REMOVE_ROW:
      icon.setAttribute('src', removeRowIcon)
      break
    case ContextMenuItemId.COPY_ROW:
      icon.setAttribute('src', copyRowIcon)
      break
    case ContextMenuItemId.CUT_ROW:
      icon.setAttribute('src', cutRowIcon)
      break
    case ContextMenuItemId.EXPAND_ALL:
      icon.setAttribute('src', expandRowIcon)
      break
    case ContextMenuItemId.COLLAPSE_ALL:
      icon.setAttribute('src', collapseRowIcon)
      break
    case ContextMenuItemId.EXPAND_TO_LEVEL_MENU:
      icon.setAttribute('src', accountTreeIcon)
      break
    case ContextMenuItemId.EXPORT_ALL:
      icon.setAttribute('src', exportRowIcon)
      break
    case ContextMenuItemId.PASTE_ROW_AS_CHILD:
    case ContextMenuItemId.INSERT_CUT_ROW:
      icon.setAttribute('src', pasteRowIcon)
      break
    case ContextMenuItemId.PASTE_ROW_AS_CHILD_NAME:
      icon.setAttribute('src', nameOnlyIcon)
      break
    case ContextMenuItemId.PASTE_ROW_AS_CHILD_SELECT:
      icon.setAttribute('src', selectDataIcon)
      break
    case ContextMenuItemId.ADD_ROW:
      icon.setAttribute('src', addRowIcon)
      break
    case ContextMenuItemId.ADD_MULTIPLE_ROW:
      icon.setAttribute('src', addRowsIcon)
      break
    case ContextMenuItemId.GET_PLAN_FROM_CHILDREN_BOTH_DATE:
      icon.setAttribute('src', bothDateIcon)
      break
    case ContextMenuItemId.GET_PLAN_FROM_CHILDREN_EARLIEST_DATE:
      icon.setAttribute('src', earliestDateIcon)
      break
    case ContextMenuItemId.GET_PLAN_FROM_CHILDREN_LATEST_DATE:
      icon.setAttribute('src', latestDateIcon)
      break
    case ContextMenuItemId.OPEN_PROGRESS_REPORT:
      icon.setAttribute('src', openProgressReportIcon)
      break
    case ContextMenuItemId.OPEN_SPRINT_REPORT:
      icon.setAttribute('src', sprintReportIcon)
      break
    case ContextMenuItemId.SEARCH_DELAYED_WBS:
      icon.setAttribute('src', showDelayedWbsIcon)
      break
    case ContextMenuItemId.OPEN_TICKET_LIST:
      icon.setAttribute('src', showTicketListIcon)
      break
    case ContextMenuItemId.GET_PLAN_FROM_CHILDREN:
      icon.setAttribute('src', reflectChildWbsIcon)
      break
    case ContextMenuItemId.EDIT:
      icon.setAttribute('src', editInformationIcon)
      break
    case ContextMenuItemId.LOGIN_PROJECT:
      icon.setAttribute('src', loginProjectIcon)
      break
    case ContextMenuItemId.DISPLAY_GRAPH:
      icon.setAttribute('src', displayGraphIcon)
      break
    case ContextMenuItemId.ADD_MEMBER:
      icon.setAttribute('src', addUserIcon)
      break
    case ContextMenuItemId.ADD_TEAM:
      icon.setAttribute('src', addTeamIcon)
      break
    case ContextMenuItemId.RESEND_REGISTRATION_EMAIL:
      icon.setAttribute('src', resendRegistrationEmailIcon)
      break
    case ContextMenuItemId.RESET_PASSWORD:
      icon.setAttribute('src', resetPasswordIcon)
      break
    case ContextMenuItemId.TEMPORARY_PASSWORD:
      icon.setAttribute('src', temporaryPasswordIcon)
      break
    case ContextMenuItemId.REMOVE_USER:
      icon.setAttribute('src', removeUserIcon)
      break
    case ContextMenuItemId.SWITCH_ROOT_WBS_ITEM:
      icon.setAttribute('src', openInNewIcon)
      break
    case ContextMenuItemId.OPEN_KANBAN:
      icon.setAttribute('src', kanbanMaterialIcon)
      break
    case ContextMenuItemId.COPY_URL:
      icon.setAttribute('src', linkMaterialIcon)
      break
    case ContextMenuItemId.COPY_URL_AND_NAME:
      icon.setAttribute('src', linkMaterialIcon)
      break
  }
  return icon
}
